import { useEffect, useState } from 'react';
import { getInsurance } from 'api/newUniprofile';
import { InsuranceServerInfo, InsuranceFormInfo } from 'types/insurance';
import { INSURANCE_TYPE_CASH } from 'constants/common';
import { transferInsuranceToFormData } from 'utils/channel';
import { getUrlParam } from 'utils/common';
import uniprofileResumeStore from 'store/UniprofileResume';
import { INewUniprofileResume } from 'types/newUniprofile';

const DefaultInsurance: InsuranceFormInfo = {
    supportPayType: INSURANCE_TYPE_CASH,
    insurances: [],
};

export const useInsuranceInfo = (): [InsuranceFormInfo, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<InsuranceFormInfo>(DefaultInsurance);
    const isAva = getUrlParam('isAva') === 'true';
    const [getResumeInfo] = uniprofileResumeStore.useStore();

    const getResumeData = () => {
        const resumeData = getResumeInfo('data') as INewUniprofileResume;
        if (resumeData?.insurance) {
            setServiceData({
                ...resumeData.insurance,
                insurances: transferInsuranceToFormData(resumeData.insurance.stateInsuranceList || []),
            });
        }
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getInsurance();
            if (!result.error) {
                const data: InsuranceServerInfo = result?.data?.data || [];
                setServiceData({
                    ...data,
                    insurances: transferInsuranceToFormData(data.stateInsuranceList || []),
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (isAva) {
            getResumeData();
        } else {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (isAva) {
            getResumeData();
        }
    }, [getResumeInfo('data')]);

    return [serviceData, loading, fetchData];
};
